import LOAD from '../../../assets/images/load.svg'
// @styles 
import './styles.scss'

export default function LoadingField() {

    return (
        <div className='load-field__container'>
            <img src={LOAD} alt='Loading'/>
            <p>Validando...</p>
        </div>
    )
}